<!--
 * @Description: 路网实时态势
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 17:05:20
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 11:44:51
 -->
<template>
  <div class="roadRealTimeSituation">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">路网实时态势</span>
      <span class="totalCount">总计&nbsp;<span class="count">{{list.length}}</span>&nbsp;条</span>
    </div>
    <div class="list">
      <div class="items" v-for="(item, index) in list" :key="index">
        <div class="item">
          <i class="el-icon-location"> {{item.customerName}}</i>
          <span class="road">{{item.roadName}}</span>
        </div>
        <div class="item">
          <span class="eventType">事件：<span class="value">{{item.type}}</span></span>
          <span class="jamTime">预计拥堵<span class="value">{{item.jamDuration}}分钟</span></span>
        </div>
        <div class="item">
          <span class="jamMileage">拥堵里程：{{item.distance}}米</span>
          <span class="time">{{item.jamTime}}</span>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'roadRealTimeSituation',
  components: {
  },
  data () {
    return {
      list: [],
    }
  },
  methods: {
    /**
     * @description                   获取部署数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/lwtsgz/page')
        .then(res => {
          if (res.code === 0) {
            let data = res.data.list
            data.map(item => {
              item.jamTime = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date(item.jamTime))
            })
            this.list = data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .roadRealTimeSituation {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 40px;
      font-size: 20px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      position: relative;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
      .totalCount {
        height: 100%;
        position: absolute;
        right: 10px;
        top: 0;
        display: flex;
        color: #fff;
        align-items: center;
        font-size: 16px;
        .count {
          color: #05dbe3;
        }
      }
    }
    .list {
      width: 100%;
      height: calc(100% - 40px);
      background: url('/static/img/layout/listBg.png');
      background-size: 100% 100%;
      margin-top: 10px;
      overflow-y: scroll;
      .items {
        width: calc(100% - 60px);
        height: calc(33% - 40px);
        padding: 20px 30px 20px 30px;
        .item {
          display: flex;
          justify-content: space-between;
          font-size: 18px;
          margin-bottom: 4%;
          color: #d3dbde;
          .el-icon-location {
            color: #05dbe3;
          }
          .road {
            font-size: 16px;
            color: #d3dbde;
          }
          .eventType {
            .value {
              color: #ff2121;
            }
          }
          .jamTime {
            color: #05dbe3;
          }
          .time {
            font-size: 16px;
          }
        }
        .line {
          width: 100%;
          height: 2%;
          background: url('/static/img/layout/line.png');
          background-size: 100% 100%;
        }
      }
    }
  }
</style>
